import { EntityStore, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { PreCheckoutState } from './pre-checkout.model';

export function createInitialState(): PreCheckoutState {
  return {
    cpf: '',
    name: '',
    phone: '',
    route: '',
    sm: '',
    originCd: '',
    destinoCd: '',
    transporter: '',
    transporterType: '',
    hash: '',
    plates: new Array<any>(),
    stageLogin: false,
    stageVeiculo: false,
    stageViagem: false
  };
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: 'precheckout' })
export class PreCheckoutStore extends EntityStore<PreCheckoutState> {
  constructor() {
    super(createInitialState());
  }
}
